import { ReactElement } from "react"

import AmendEVDCDeviceForm from "../../../../components/devices/lct/evdc/amendEVDCDeviceForm"
import ContinueEVDCDeviceAmendmentProvider from "../../../../components/devices/lct/evdc/providers/continueEVDCDeviceAmendmentProvider"

const ContinueEVDCDraftDeviceAmendment = (): ReactElement => (
    <ContinueEVDCDeviceAmendmentProvider>
        <AmendEVDCDeviceForm />
    </ContinueEVDCDeviceAmendmentProvider>
)

export default ContinueEVDCDraftDeviceAmendment
